export const breakPointStage = (bp: string | null): number => {
  return bp ? ['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'].indexOf(bp) : 10;
};

export const compareBreakpoints = (bp1: string, bp2: string): boolean => {
  return breakPointStage(bp1) > breakPointStage(bp2);
};
// TODO DELETE ALL
